import { API_URL } from '../../../../constants';

const paths = {
  getEmployeePrivacyPolicyPdf: (): string => `${API_URL}/employee-privacy-policy`,
  getEmployeeConditionsOfUsePdf: (language: string): string =>
    `${API_URL}/employee-conditions-of-use?language=${language}`,
};

export default paths;
